import { Candidate } from '../../entities/Candidate';
import { ApiService } from '../ApiService';

export class CandidateService {
  public static show(id: number): Promise<Candidate> {
    return ApiService.get<Candidate>(`/api/v1/candidates/${id}`);
  }
}
